import { Box, ButtonBase, Typography } from "@mui/material"
import STRING_CONSTANTS from "../../shared/constants/StringConstants"
import { formatAmount } from "./format"
import schemeTokens, { softPrimary } from "./tokens"

const PresetChip = ({ selected, primary, secondary, onClick }) => (
  <ButtonBase
    onClick={onClick}
    aria-pressed={selected}
    sx={{
      display: "block",
      px: 1,
      py: 1.25,
      textAlign: "center",
      borderRadius: schemeTokens.radius.tile,
      border: selected ? "1.5px solid" : "1px solid",
      borderColor: selected ? "primary.main" : schemeTokens.color.border,
      bgcolor: selected ? softPrimary(0.08) : schemeTokens.color.surface,
      transition: "border-color .12s ease, background-color .12s ease",
    }}
  >
    <Typography
      sx={{
        fontSize: 14.5,
        fontWeight: 700,
        color: selected ? "primary.main" : "text.primary",
      }}
    >
      {primary}
    </Typography>
    {secondary && (
      <Typography sx={{ fontSize: 10, color: "grey.500", mt: 0.25 }}>
        {secondary}
      </Typography>
    )}
  </ButtonBase>
)

const AmountPresetGrid = ({
  presets,
  value,
  custom,
  maturityOf,
  onSelect,
  onSelectCustom,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 1,
    }}
  >
    {presets.map((preset) => (
      <PresetChip
        key={preset}
        selected={!custom && value === preset}
        primary={formatAmount(preset)}
        secondary={`${STRING_CONSTANTS.MATURES} ${formatAmount(
          maturityOf(preset)
        )}`}
        onClick={() => onSelect(preset)}
      />
    ))}
    <PresetChip
      selected={custom}
      primary={STRING_CONSTANTS.CUSTOM}
      secondary={STRING_CONSTANTS.ENTER_AMOUNT}
      onClick={onSelectCustom}
    />
  </Box>
)

export default AmountPresetGrid
